import { DrawingSetting, IToolbarDrawingSetting, IToolbarDrawingsSettingItem } from './interfaces'

export const drawingSettings: Record<DrawingSetting, IToolbarDrawingSetting> = {
  [DrawingSetting.PreserveDrawings]: {
    id: DrawingSetting.PreserveDrawings,
    icon: 'drawingSettingPreserveDrawings',
    iconActive: 'drawingSettingPreserveDrawingsActive',
    title: 'Preserve drawings: Off',
    titleActive: 'Preserve drawings: On',
  },
  [DrawingSetting.DrawingModeContinuous]: {
    id: DrawingSetting.DrawingModeContinuous,
    icon: 'drawingSettingDrawingMode',
    iconActive: 'drawingSettingDrawingModeActive',
    title: 'Drawing mode: Single',
    titleActive: 'Drawing mode: Continuous',
  },
  [DrawingSetting.HideDrawings]: {
    id: DrawingSetting.HideDrawings,
    icon: 'drawingSettingHide',
    iconActive: 'drawingSettingShow',
    title: 'Hide drawings',
    titleActive: 'Show drawings',
  },
  [DrawingSetting.LockDrawings]: {
    id: DrawingSetting.LockDrawings,
    icon: 'drawingSettingLock',
    iconActive: 'drawingSettingUnlock',
    title: 'Lock drawings',
    titleActive: 'Unlock drawings',
  },
}

export const toolbarDrawingSettings: Array<IToolbarDrawingsSettingItem> = [
  {
    defaultItem: drawingSettings[DrawingSetting.DrawingModeContinuous],
  },
  {
    defaultItem: drawingSettings[DrawingSetting.PreserveDrawings],
  },
  {
    defaultItem: drawingSettings[DrawingSetting.HideDrawings],
  },
  {
    defaultItem: drawingSettings[DrawingSetting.LockDrawings],
  },
]
